import { Routes } from '@angular/router';
import { HomeComponent } from '@comp/home/home.component';
import { LoginComponent } from '@comp/unauthenticated/login/login.component';
import { SignInComponent } from '@comp/unauthenticated/signin/signin.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    title: 'Home',
    component: HomeComponent,
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'login',
    title: 'Login',
    component: LoginComponent,
    data: { public: true, hideHeader: true },
  },
  {
    path: 'signin',
    title: 'SignIn',
    component: SignInComponent,
    data: { public: true, hideHeader: true },
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
    data: { public: true, hideHeader: true },
  },
  {
    path: 'register',
    title: 'Register New User',
    loadComponent: () =>
      import('./components/unauthenticated/register/register.component').then(
        (c) => c.RegisterComponent,
      ),
    data: { public: true, hideHeader: true },
  },
  {
    path: 'what-is-mysoftpro',
    title: 'What Is mySoftPro?',
    loadComponent: () =>
      import('./components/unauthenticated/what-is-mysoftpro/what-is-mysoftpro.component').then(
        (c) => c.WhatIsMysoftproComponent,
      ),
    data: { public: true, hideHeader: true },
  },
  {
    path: 'downloads',
    title: 'Downloads',
    loadComponent: () =>
      import('./components/unauthenticated/downloads/downloads.component').then(
        (c) => c.DownloadsComponent,
      ),
    data: { public: true, hideHeader: true },
  },
  {
    path: 'contact-us',
    title: 'Contact Us',
    canActivate: [OktaAuthGuard],
    loadComponent: () =>
      import('./components/contact-us/contact-us.component').then(
        (c) => c.ContactUsComponent,
      ),
  },
  {
    path: 'documents',
    title: 'Documents',
    loadComponent: () =>
      import('./components/documents/documents.component').then(
        (c) => c.DocumentsComponent,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'ideas-portal',
    title: 'Ideas Portal',
    loadComponent: () =>
      import('./components/ideas-portal/ideas-portal.component').then(
        (c) => c.IdeasPortalComponent,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'hosted-portal',
    title: 'Hosted Portal',
    loadComponent: () =>
      import('./components/hosted-portal/hosted-portal.component').then(
        (c) => c.HostedPortalComponent,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'online-bill-pay',
    title: 'Online Bill Pay',
    loadComponent: () =>
      import('./components/online-bill-pay/online-bill-pay.component').then(
        (c) => c.OnlineBillPayComponent,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'users',
    title: 'Users',
    loadComponent: () =>
      import('./components/users/users.component').then(
        (c) => c.UsersComponent,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'hostedclientdownloads',
    title: 'Hosted Client Downloads',
    loadComponent: () =>
      import('./components/downloads-hostedclient/downloads-hostedclient.component').then(
        (c) => c.DownloadsHostedClientComponentComponent,
      ),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq',
    title: 'mySoftPro FAQ',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'general' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/invoicing',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'invoicing' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/ams',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'ams' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/payments',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'payments' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/ideas-portal',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'ideas-portal' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/documents',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'documents' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/support',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'support' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/hosted-user-management',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'hosted-user-management' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'faq/mysoftpro-user-management',
    loadComponent: () =>
      import('./components/faq/faq.component').then((c) => c.FaqComponent),
    data: { view: 'mysoftpro-user-management' },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'page-not-found',
    title: 'Page Not Found',
    component: PageNotFoundComponent,
    canActivate: [OktaAuthGuard],
    data: { public: true },
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
  },
];
